export default function queryString() {
    function getUrlParamString(key, val) {
        return key + "=" + encodeURIComponent(val);
    }
    return {
        getString: function (obj) {
            var arr = [];
            for (var n in obj) {
                var val = obj[n];
                if (val instanceof Array) {
                    for (var i = 0; i < val.length; i++) {
                        var valItem = val[i];
                        arr.push(getUrlParamString(n, valItem));
                    }
                } else {
                    if (typeof (val) !== "undefined")
                    arr.push(getUrlParamString(n, val));
                }
            }
            return arr.join("&");
        },
        parse: function (str) {
            var obj = {};
            if (str && str !== "") {
                var arr = str.split('&');
                for (var i = 0; i < arr.length; i++) {
                    var keyValStr = arr[i];
                    var pair = keyValStr.split("=");
                    if (pair.length === 2) {
                        var key = pair[0];
                        var val = pair[1];

                        if (typeof obj[key] === "undefined") {
                            obj[key] = [];
                        }
                        obj[key].push(decodeURIComponent(val));
                    }
                }
            }
            return obj;
        }
    }
}